import { render } from "./Box.vue?vue&type=template&id=77444c67&scoped=true"
import script from "./Box.vue?vue&type=script&setup=true&lang=js"
export * from "./Box.vue?vue&type=script&setup=true&lang=js"

import "./Box.vue?vue&type=style&index=0&id=77444c67&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77444c67"],['__file',"src/components/dialogs/Box.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77444c67"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77444c67', __exports__)) {
    api.reload('77444c67', __exports__)
  }
  
  module.hot.accept("./Box.vue?vue&type=template&id=77444c67&scoped=true", () => {
    api.rerender('77444c67', render)
  })

}


export default __exports__